<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { useAppToast } from '@/composables/useAppToast'

const { t } = useI18n()
const toast = useAppToast()
const loading = ref(false)
const { adminModeEnabled, canUseAdminMode, toggleAdminMode } = useAdminMode()

const handleToggle = async () => {
  if (loading.value) {
    return
  }

  try {
    loading.value = true
    await toggleAdminMode()
  } catch {
    toast.add({
      color: 'error',
      title: t('common.labels.error'),
      description: t('components.adminModeToggle.updateError'),
      duration: 4000,
    })
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <div v-if="canUseAdminMode" class="flex items-center">
    <button
      v-app-tooltip.bottom="
        adminModeEnabled
          ? t('components.adminModeToggle.enabledTooltip')
          : t('components.adminModeToggle.disabledTooltip')
      "
      class="topbar-item"
      :class="{ 'bg-orange-400! text-white dark:bg-orange-700!': adminModeEnabled }"
      :aria-label="t('components.adminModeToggle.ariaLabel')"
      :disabled="loading"
      @click="handleToggle"
    >
      <UIcon name="i-lucide-database" />
    </button>
  </div>
</template>
